import type { UTCTime } from '../../interface/ITimezone';

export const getLanguage = () => {
  return document.documentElement?.lang || window?.userData?.locale?.split('-')?.[0] || 'en';
};

export const zeroPad = (value: number | string) => {
  const str = typeof value !== 'string' ? `${value}` : value;
  return str?.padStart(2, '0');
};

export const getTimeSelectOption = () => {
  let option = [];
  for(let i = 0; i < 24; i++) {
    option.push(setTimeSelectOption({
      title: `${zeroPad(i > 12 ? i % 12 : i)}:00 ${i >= 12 ? 'PM' : 'AM'}`,
      value: `${zeroPad(i)}:00`
    }));
  }
  return option;
};

export const setTimeSelectOption = (data: string | {[key: string]: string}) => {
  return typeof data === 'string' ? {title: data, value: data} : data;
};

// UTC Time으로 반환
export const setDateTime = (dateTime?: string | number): UTCTime => {
  const reDateTime = typeof dateTime === 'string' ? dateTime?.replace(/\[([^[\]]*)\]/, '') : dateTime; // [Asia/Seoul]같은 timezone 정보 제거
  const date = reDateTime ? new Date(reDateTime) : new Date();
  return isNaN(date?.getTime()) ? new Date()?.getTime() : date?.getTime();
};

export const setDateString = (year: number, month: number, date: number, hour: number, minute: number) => {
  return `${year}/${zeroPad(month)}/${zeroPad(date)} ${zeroPad(hour)}:${zeroPad(minute)}`;
};


export const getServerLocalTimeDiff = (serverTime: string) => {
  if(!serverTime) {
    return 0;
  }

  return setDateTime(serverTime) - setDateTime();
};